import { IconProps, PawPrintIcon, ShieldIcon, WalletIcon } from '@phosphor-icons/react';
import React from 'react';

import { close } from 'ionicons/icons';

import { usePetForm } from '../../../hooks/Pet/usePetForm';
import { Pet } from '../../../types/Pet/types';
import CodVendedorAlert from '../../Otros/CodVendedorAlert';
import Alert from '../../UI/Alert';
import FormHeader from '../../UI/FormHeader';
import Navigation from '../../UI/Navigation';
import Spinner from '../../UI/Spinner';
import StepWrapper from '../../UI/StepWrapper';
import PetFormStep1 from '../PetForm_1';
import PetFormStep2 from '../PetForm_2';
import PetFormStep3 from '../PetForm_3';
import './PetForm.scss';

const iconLocalProps: IconProps = { weight: 'fill' };

const getSteps = (petData?: Pet) => [
  {
    icon: <PawPrintIcon {...iconLocalProps} />,
    title: 'Mi mascota',
    subtitle: petData ? 'Editá los datos de tu mascota' : 'Datos del nuevo integrante',
  },
  {
    icon: <ShieldIcon {...iconLocalProps} />,
    title: 'Plan',
    subtitle: 'Elegí la cobertura más conveniente',
  },
  {
    icon: <WalletIcon {...iconLocalProps} />,
    title: 'Medio de pago',
    subtitle: 'Completá los datos de pago',
  },
];

interface PetFormProps {
  pet?: Pet;
  closeModal?: () => void;
}

const PetForm: React.FC<PetFormProps> = ({ pet: petData, closeModal }) => {
  const steps = getSteps(petData);

  const {
    pet,
    setPet,
    plan,
    setPlan,
    datosPagoPreloaded,

    razas,
    planes,
    preciosPlanes,
    metodosPago,

    onSubmit,
    submitSolicitud,
    isSubmitting,

    isInitialized,
    isValidatingRazas,
    isValidatingPlanes,
    isCodVendedorAlertOpen,
    setIsCodVendedorAlertOpen,

    currentStep,
    totalSteps,
    isFirst,
    next,
    back,

    alertState,
    hideAlert,

    handleCodVendedorSubmit,
    codVendedorAlertShownRef,
  } = usePetForm({
    petData,
    closeModal,
    totalSteps: steps.length,
  });

  if (!isInitialized || (currentStep === 2 && isValidatingPlanes)) {
    return <Spinner fullscreen />;
  }

  return (
    <div className="pet-form">
      <Navigation
        startIcon={isFirst ? close : undefined}
        onBack={isFirst ? closeModal : back}
        {...(!petData ? { currentStep, totalSteps } : {})}
      />

      <div className="ion-padding-horizontal">
        <FormHeader {...steps[currentStep - 1]} />

        <StepWrapper show={currentStep === 1}>
          <PetFormStep1
            pet={pet}
            setPet={setPet}
            petData={petData}
            razas={razas}
            goForward={!petData ? next : submitSolicitud}
            isSubmitting={isSubmitting}
            isLoading={isValidatingRazas}
          />
        </StepWrapper>

        <StepWrapper show={currentStep === 2}>
          <PetFormStep2
            planes={planes}
            plan={plan}
            setPlan={setPlan}
            preciosPlanes={preciosPlanes}
            goForward={next}
          />
        </StepWrapper>

        <StepWrapper show={currentStep === 3}>
          <PetFormStep3
            datosPagoPreloaded={datosPagoPreloaded}
            metodosPago={metodosPago}
            setIsCodVendedorAlertOpen={setIsCodVendedorAlertOpen}
            codVendedorAlertShownRef={codVendedorAlertShownRef}
            onSubmit={onSubmit}
            isSubmitting={isSubmitting}
          />
        </StepWrapper>
      </div>

      <CodVendedorAlert
        isOpen={isCodVendedorAlertOpen}
        setOpen={setIsCodVendedorAlertOpen}
        setCodVendedor={handleCodVendedorSubmit}
      />

      <Alert
        isOpen={alertState.isOpen}
        header={alertState.header}
        message={alertState.message}
        buttons={alertState.buttons}
        onDidDismiss={hideAlert}
      />
    </div>
  );
};

export default PetForm;
